import { ICustomEntryPoint } from "../GameEntryPoint";
import { IGameState } from "../../IGameState";
import SDKIntegrationsHelper from "../../../../Utility/SDK/SDKIntegrationsHelper";
import { queuePopup } from "../../../UI/UIStateHelper";
import Game from "../../../../Game";

export function requestLife(payload: ICustomEntryPoint, state: IGameState){
    SDKIntegrationsHelper.giveLife(
        payload.userId,
        payload.userName
    );
    return {
        ...state,
        UIState: queuePopup(state.UIState, 'sendLivesMenu', {
            title: `${Game.locale.getText('SentLives')}${
                payload.userName
            }`,
        }),
    };
}
